import { Flex, Modal, Text } from "@mantine/core";

import { InvoicesTable } from "../../components/Invoice/InvoicesTable/InvoicesTable.tsx";
import { Paymaster } from "../../types/paymaster.ts";

interface Props {
  paymaster: Paymaster;
  opened?: boolean;
  onClose: () => void;
}

export const PaymasterInvoicesModal = ({
  paymaster,
  opened = true,
  onClose,
}: Props) => {
  return (
    <Modal title="Invoices Details" size="xl" opened={opened} onClose={onClose}>
      <Flex justify="space-between" align="center" pb={20} pl={5}>
        <Text weight="bolder">Total Invoices: {paymaster.invoices.length}</Text>
      </Flex>
      <Flex direction="column" gap={8}>
        <InvoicesTable
          filter={{ id: { in: paymaster.invoices.map((i) => i.id) } }}
          canEditCollectorAssigned={false}
        />
      </Flex>
    </Modal>
  );
};
